import { render, staticRenderFns } from "./GeneralSettingIndex.vue?vue&type=template&id=98fecddc&scoped=true&"
import script from "./GeneralSettingIndex.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingIndex.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettingIndex.vue?vue&type=style&index=0&id=98fecddc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fecddc",
  null
  
)

export default component.exports